package dev.lingvo.site.pages.app.projects.slug.settings

import kotlinx.coroutines.CancellationException

/**
 * Runs a settings mutation and reports only real failures.
 *
 * **`runCatching` is wrong for anything that suspends.** It catches `Throwable`, and that includes
 * the `CancellationException` Compose throws through a `rememberCoroutineScope` job the moment the
 * surface that launched it leaves composition — a navigation, a closed dialog, a provider swapped
 * for another. Caught as a failure, an ordinary "the user moved on" becomes a red toast reporting an
 * error that never happened, over a screen that no longer exists, while the operation itself is left
 * in whatever state it reached.
 *
 * Cancellation is rethrown so the coroutine machinery can finish unwinding; everything else comes
 * back as [Result.failure] for the caller to show.
 */
internal suspend fun <T> settingsOperationResult(block: suspend () -> T): Result<T> = try {
    Result.success(block())
} catch (cancelled: CancellationException) {
    throw cancelled
} catch (failure: Throwable) {
    Result.failure(failure)
}
